import React, { useState, useEffect, useContext } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import {
  CustomizationEditorProps,
  EditorOption,
} from '../../../Layout/Trigger/Model/EditorModel';
import { Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import PermissionConstants from '../../../Common/Constants/PermissionConstants';
import { PreferredThemeContext } from '../../../../Theme/UseToggleDarkMode';
import { CustomerDispatchContext } from '../Reducer/CustomizationState';
import { showToast } from '../../../../lib/toast';
import { useTranslation } from 'react-i18next';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/theme/xq-light.css';
import 'codemirror/theme/neat.css';
import 'codemirror/mode/sql/sql.js';
import 'codemirror/mode/powershell/powershell.js';

const useStyles = makeStyles()(() => ({
  root: {
    width: '100%',
  },
  codeMirror: {
    height: '40vh',
  },
}));

export default function CustomizationEditor(
  props: Readonly<CustomizationEditorProps>,
) {
  const { content, editorContentChangedCallback, actiontype, mode } = props;
  const { classes } = useStyles();
  const { t } = useTranslation('customer');

  const [editorValue, setEditorValue] = useState('');

  const permissions = useContext(PermissionsContext);
  const prefersDarkMode = useContext(PreferredThemeContext);

  useEffect(() => {
    setEditorValue(content);
  }, [content]);

  const onEditorChange = (value: string) => {
    editorContentChangedCallback();
    if (lengthLimit(value)) {
      showToast({
        title: t('customization.info.maxLengthReached'),
        type: 'info',
      });
    }
  };

  const options: EditorOption = {
    mode: mode,
    theme: prefersDarkMode ? 'material' : 'xq-light',
    lineNumbers: true,
    readOnly: permissions[PermissionConstants.CustomerWriter]
      ? false
      : 'nocursor',
  };

  const lengthLimit = (value: string) => {
    if (value.length > 1070000000) {
      return true;
    }
  };

  return (
    <Paper className={classes.root}>
      <CustomerDispatchContext.Consumer>
        {(dispatch) => (
          <CodeMirror
            className={classes.codeMirror}
            value={editorValue}
            options={options}
            editorDidMount={(editor) => {
              editor.setSize('', '40vh');
            }}
            onBeforeChange={(editor, data, value) => {
              dispatch({ type: actiontype, payload: value });
              setEditorValue(value);
            }}
            onChange={(editor, data, value) => {
              onEditorChange(value);
            }}
          />
        )}
      </CustomerDispatchContext.Consumer>
    </Paper>
  );
}
